<template>
  <div class="container">
    <van-sticky>
      <van-nav-bar title="退款详情" left-arrow @click-left="goBack" />
    </van-sticky>
    <div class="header" v-if="detailInfo.status === 0">
      <h3><van-icon name="clock" /> 申请已提交，商家处理中</h3>
      <!-- <p style="color: red">剩1天11时59分</p> -->
      <div class="explain">
        <p>若商家同意：申请将达成并退至您的支付账号</p>
        <p>若商家拒绝：联系商家确认或再次发起申请</p>
        <p>若商家未处理：超时系统自动为您退款</p>
      </div>
    </div>

    <div class="header" v-if="detailInfo.status === 1">
      <h3><van-icon name="shop" /> 商家同意退款，请及时退货</h3>
      <div class="explain">
        <p>1.寄回商品，并记录快递单号</p>
        <p>2.及时填写退货快递单号</p>
        <p>退货地址：{{ detailInfo.addressName + detailInfo.street }}</p>
        <p>联系人：{{ detailInfo.contacts }}</p>
        <p>电话：{{ detailInfo.phoneNumber }}</p>
      </div>
    </div>

    <div class="header" v-if="detailInfo.status === 2">
      <h3><van-icon name="clock" /> 退货中</h3>
      <p>等待卖家确认收货后同意退款</p>
    </div>

    <div class="header" v-if="detailInfo.status === 3">
      <h3><van-icon name="clock" /> 买家已退货，退款中</h3>
    </div>

    <div class="header" v-if="detailInfo.status === 4">
      <h3><van-icon name="checked" /> 已完成</h3>
       <p>您申请的退款金额{{ detailInfo.returnAmount }}元已退回给您的账账户中，请注意查收</p>
    </div>

    <div class="header" v-if="detailInfo.status === 5"> 
      <h3><van-icon name="clear" /> 商家已拒绝申请</h3>
      <p>拒绝理由：{{ detailInfo.rejectReason }}</p>
      <div class="explain">
        <p>若商家同意：申请将达成并退至您的支付账号</p>
        <p>若商家拒绝：联系商家确认或再次发起申请</p>
        <p>若商家未处理：超时系统自动为您退款</p>
      </div>
    </div>

    <div class="header" v-if="detailInfo.status === 6">
      <h3><van-icon name="clear" /> 申请已撤销</h3>
      <div class="explain">
        <p>
          您已撤销此次退款申请，若您的问题未解决，可以在有效期（确认收货后15天）内再次申请。
        </p>
      </div>
    </div>

    <div class="order">
      <p>订单编号：{{ detailInfo.orderSn }}</p>
      <p>申请时间：{{ detailInfo.createTime }}</p>
      <p>售后类型：{{ detailInfo.afterSaleType ? '退货退款' : '退款' }}</p>
      <p>收货状态：{{ detailInfo.receiptStatus ? '已收货' : '未收货' }}</p>
      <p>退款金额：￥{{ detailInfo.returnAmount }}</p>
      <p>退款原因：{{ detailInfo.applyDescription }}</p>
      <p>商品名称：{{ detailInfo.title }}</p>
      <p v-if="detailInfo.returnTrackingNumber">
        退货快递单号：{{ detailInfo.returnTrackingNumber }}
      </p>
      <p v-if="detailInfo.returnLeaveMessage">
        退货留言：{{ detailInfo.returnLeaveMessage }}
      </p>
    </div>
    <div style="height: 50px"></div>
    <div class="bottom">
      <van-button
        @click="doCancel"
        v-if="
          detailInfo.status !== 6 &&
          detailInfo.status !== 4 &&
          detailInfo.status !== 5 && detailInfo.status !== 3
        "
        >撤销申请</van-button
      >&emsp;
      <van-button @click="goodsReturn" v-if="detailInfo.status === 1"
        >填写退货单号</van-button
      >
    </div>
  </div>
</template>

<script>
import { detail, cancel } from '@/api/after-sale'
export default {
  data() {
    return {
      detailInfo: '',
    }
  },
  created() {
    this.getdetail()
  },
  methods: {
    getdetail() {
      detail(this.$route.query.id).then(({ data }) => {
        if (data.code === 200) {
          this.detailInfo = data.data
          console.log('this.detailInfo', this.detailInfo)
        }
      })
    },
    // 申请状态,可用值:0 (待处理) ,1 (等待买家退货) ,2 (退货中) ,3 (退款中) ,4 (已完成) ,5 (已拒绝) ,6 (已撤销)
    getStatusName(num) {
      switch (num) {
        case 0:
          return '待处理'
        case 1:
          return '等待买家退货'
        case 2:
          return '退货中'
        case 3:
          return '退款中'
        case 4:
          return '已完成'
        case 5:
          return '已拒绝'
        case 6:
          return '已撤销'
      }
    },
    doCancel() {
      this.$dialog
        .confirm({
          title: '撤销申请',
          message: '是否撤销该退款申请',
        })
        .then(() => {
          const toast = this.$toast.loading({
            message: '提交中',
            forbidClick: true,
            loadingType: 'spinner',
            duration: 0,
          })
          cancel(this.$route.query.id)
            .then(({ data }) => {
              if (data.code === 200) {
                this.getdetail()
                this.$toast('撤销申请成功')
              }
            })
            .finally(() => {
              toast.clear()
            })
        })
        .catch(() => {})
    },
    goodsReturn() {
      this.$router.push({
        path: '/after-sale/return-form',
        query: {
          id: this.$route.query.id,
        },
      })
    },
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  background: #efefef;
  min-height: 100vh;
}
.header {
  background: #fff;
  padding: 10px 15px;
  color: #606266;
  h3 {
    color: #000;
    font-size: 18px;
    font-weight: 500;
    margin: 0 0 5px 0;
  }
  p {
    font-size: 14px;
    margin: 0 25px;
  }
  /deep/ .van-icon {
    font-size: 20px;
    color: rgb(254, 186, 13);
  }
  .explain {
    padding: 10px 0;
    p {
      font-size: 14px;
      margin: 5px 0;
    }
  }
}
.order {
  margin: 10px 0;
  background: #fff;
  padding: 10px 15px;
  color: #606266;
  p {
    font-size: 14px;
    margin: 5px 0;
  }
}
.bottom {
  background: #efefef;
  text-align: right;
  padding: 10px;
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  button {
    border-radius: 5px;
    height: 35px;
    border-color: #ee0a24;
    color: #ee0a24;
  }
}
</style>